"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ducd_1 = require("ducd");
const split_js_1 = require("split.js");
class Splitter {
    constructor(args) {
        this.args = args;
        this.ui = SplitterHTML({ parent: args.parent });
        this.splitterJs = split_js_1.default([this.ui.left, this.ui.right], {
            sizes: [this.args.splitterProportion, 100 - this.args.splitterProportion],
            gutterSize: 74,
            minSize: 0,
            snapOffset: 100,
            cursor: 'e-resize',
            onDragStart: this.args.onDragStart,
            onDragEnd: this.args.onDragEnd
        });
    }
    setSizes(s, ballback) {
        const ist = this.splitterJs.getSizes();
        const newEqualOld = ist[0] == s[0] && ist[1] == s[1];
        if (newEqualOld) {
            ballback();
            return;
        }
        console.warn('SPLITTER: setSize (incl. transition)', s);
        const once = (e, tstr, b) => {
            e.style.transition = tstr;
            e.addEventListener('transitionend', event => {
                if (event.srcElement === e && event.propertyName === 'width') {
                    e.style.transition = '';
                    b();
                }
            }, false);
        };
        let done = 0;
        once(this.ui.left, 'width 500ms ease-out', () => { if (++done == 2)
            ballback(); });
        once(this.ui.right, 'width 500ms ease-out', () => { if (++done == 2)
            ballback(); });
        this.splitterJs.setSizes(s);
        ballback();
    }
    getSizes() {
        const s = this.splitterJs.getSizes();
        console.assert(s.length === 2);
        return s;
    }
}
exports.Splitter = Splitter;
var html = `<div class="splitter">
        <div class="left"></div>
        <div class="right"></div>
        <div id="toast-container"></div>
    </div>`;
function SplitterHTML(args) {
    var ui = ducd_1.HTML.parse(html)();
    args.parent.appendChild(ui);
    ui.left = ui.children[0];
    ui.right = ui.children[1];
    return ui;
}
exports.SplitterHTML = SplitterHTML;



//////////////////
// WEBPACK FOOTER
// ./dist/js/components/splitter/splitter.js
// module id = 416
// module chunks = 0